import { Box } from "@material-ui/core"
import moment from "moment"
import styled from "styled-components"
import colors from "theme/colors"

const StyledBox = styled(Box)``

const StyledUl = styled.ul`
  padding: 0px;
  padding-right: 10px;
  margin-bottom: 20px;
  margin-top: 0px;
`
const StyledLi = styled.li`
  font-size: 16px;
  font-family: NarkisBlock;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: right;
  margin-top: 10px;
  color: ${colors.darkGreen};
  text-align: right;
  ::marker {
    color: ${colors.yellow};
  }
`

type PaymentSchedulerTextProps = {
  endDate: Date | string
  scheduleType: string
  startDate: Date | string
}

const PaymentSchedulerText = ({
  endDate,
  scheduleType,
  startDate,
}: PaymentSchedulerTextProps) => {
  const getTypeText = () => {
    const formatedDate = moment(endDate).format("DD/MM/YYYY")
    if (scheduleType === "Daily") {
      return `כל יום יישלח גיפטקארד חדש עד לתאריך ${formatedDate}`
    }
    if (scheduleType === "Weekly") {
      return `כל שבוע יישלח גיפטקארד חדש עד לתאריך ${formatedDate}`
    }
    if (scheduleType === "Monthly") {
      return `כל חודש יישלח גיפטקארד חדש עד לתאריך ${formatedDate}`
    }
    if (scheduleType === "Yearly") {
      return `כל שנה יישלח גיפטקארד חדש עד לתאריך ${formatedDate}`
    }
  }

  return (
    <StyledBox>
      <StyledUl>
        <StyledLi>
          הגיפטקארד הראשון יישלח בתאריך {moment(startDate).format("DD/MM/YYYY")}
        </StyledLi>
        <StyledLi>{getTypeText()}</StyledLi>
        <StyledLi>החיוב עבור כל גיפטקארד יתבצע בנפרד לפני שליחתו</StyledLi>
      </StyledUl>
    </StyledBox>
  )
}

export default PaymentSchedulerText
